// src/config/plotConfigs/differentialExpressionConfig.js

export const differentialExpressionConfig = {
  sections: [
    {
      fields: [
        {
          id: "riboRegion",
          label: "Ribo-Seq Region",
          type: "radio",
          options: [
            { value: "fiveprime", label: "5' UTR" },
            { value: "cds", label: "CDS" },
            { value: "threeprime", label: "3' UTR" },
            { value: "all", label: "All" },
          ],
          tooltip:
            "This determines which region the Ribo-Seq counts for a particular gene will be taken from, if set to 'All' counts will be a sum of the 5'/CDS/3' regions. *NOTE: This only applies to coding genes.",
          width: 3,
        },
        {
          id: "rnaRegion",
          label: "RNA-Seq Region",
          type: "radio",
          options: [
            { value: "fiveprime", label: "5' UTR" },
            { value: "cds", label: "CDS" },
            { value: "threeprime", label: "3' UTR" },
            { value: "all", label: "All" },
          ],
          tooltip:
            "This determines which region the RNA-Seq counts for a particular gene will be taken from, if set to 'All' counts will be a sum of the 5'/CDS/3' regions. *NOTE: This only applies to coding genes.",
          width: 3,
        },
        // ✅ ADVANCED SETTINGS - These will be shown in modal
        {
          id: "geneType",
          label: "Gene Type",
          type: "radio",
          options: [
            { value: "all", label: "All" },
            { value: "coding", label: "Coding" },
            { value: "noncoding", label: "Non-coding" },
          ],
          tooltip:
            "Carry out the search using coding genes, non-coding genes or all genes",
          width: 12,
          advanced: true,
        },
        {
          id: "maxPadj",
          label: "Max padj (%)",
          type: "text",
          placeholder: "5.0",
          tooltip:
            "This value represents the max p-adjusted value that will be used to consider genes significant. The values is a percentage so entering 5 in this box will count all genes with a p-adjusted values below 5% as significant. The default value for the deltaTE plot is 5.",
          width: 12,
          advanced: true,
        },
        {
          id: "xMin",
          label: "X-axis Min",
          type: "text",
          placeholder: "Min",
          tooltip:
            "Optionally manually set the x-axis scale of the plot, if left empty scaling will be automatic. Note that the values on the plot are log2 values.",
          width: 6,
          advanced: true,
        },
        {
          id: "xMax",
          label: "X-axis Max",
          type: "text",
          placeholder: "Max",
          tooltip:
            "Optionally manually set the x-axis scale of the plot, if left empty scaling will be automatic. Note that the values on the plot are log2 values.",
          width: 6,
          advanced: true,
        },
        {
          id: "yMin",
          label: "Y-axis Min",
          type: "text",
          placeholder: "Min",
          tooltip:
            "Optionally manually set y-axis scale of the plot, if left empty scaling will be automatic. Note that the values on the plot are log2 values.",
          width: 6,
          advanced: true,
        },
        {
          id: "yMax",
          label: "Y-axis Max",
          type: "text",
          placeholder: "Max",
          tooltip:
            "Optionally manually set y-axis scale of the plot, if left empty scaling will be automatic. Note that the values on the plot are log2 values.",
          width: 6,
          advanced: true,
        },
        // BATCH SETTINGS - These will only be shown in 'batch' mode
        {
          id: "email",
          label: "Email notification",
          type: "checkbox",
          tooltip:
            "If checked an email notification will be sent to you once the job has completed. The email will contain a link to the results of this job.",
          width: 12,
          mode: "batch"
        },
        {
          id: "batchPlotType",
          label: "Plot type",
          type: "radio",
          options: [
            { value: "plot_te", label: "TE" },
            { value: "plot_ribo", label: "Ribo-seq (Volcano)" },
            { value: "plot_rna", label: "RNA-Seq (Volcano)" },
          ],
          tooltip:
            "Select whether to plot compare TE (both Ribo-Seq & RNA-seq) or just Ribo-Seq/RNA-Seq individually",
          width: 6,
          mode: "batch"
        },
      ],
    },
  ],
};

export const differentialExpressionDefaults = {
  geneType: "coding",
  maxPadj: 5.0,
  riboRegion: "cds",
  rnaRegion: "all",
  xMin: "",
  xMax: "",
  yMin: "",
  yMax: "",
  batchPlotType: "plot_te",
};

